import { render } from "./SupplierDue.vue?vue&type=template&id=7d476da9&scoped=true"
import script from "./SupplierDue.vue?vue&type=script&lang=js"
export * from "./SupplierDue.vue?vue&type=script&lang=js"

import "./SupplierDue.vue?vue&type=style&index=0&id=7d476da9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d476da9"]])

export default __exports__